import { createStore } from 'jotai';

export const appStore = createStore();
